// File-related API calls
import api from './api';

const fileApi = {
  // Filter files to most relevant subset using AI
  filterFiles: (fileIds, count = 80) => {
    return api.post('/files/filter-files', { fileIds, count });
  },
  // List all files with optional filters
  getFiles: (params = {}) => {
    return api.get('/files', params);
  },
  
  // Get files by file set ID
  getFilesByFileSet: (fileSetId) => {
    return api.get('/files', { fileSetId });
  },
  
  // Get files by scrape job ID
  getFilesByScrapeJob: (scrapeJobId, fileType) => {
    return api.get('/files', { scrapeJobId, fileType });
  },
  
  // Group files by type
  groupFilesByType: (files) => {
    return files.reduce((grouped, file) => {
      const type = file.type || 'other';
      if (!grouped[type]) grouped[type] = [];
      grouped[type].push(file);
      return grouped;
    }, {});
  },
  
  // Get a specific file by ID
  getFile: (fileId) => {
    return api.get(`/files/${fileId}`);
  },
  
  // Get a presigned URL for file upload
  getUploadUrl: (data) => {
    return api.post('/files/upload-url', data);
  },
  
  // Upload a file to the presigned URL
  uploadFile: async (uploadUrl, file) => {
    try {
      const response = await fetch(uploadUrl, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type,
        },
      });
      
      if (!response.ok) {
        throw new Error('File upload failed');
      }
      
      return true;
    } catch (error) {
      console.error('File upload error:', error);
      throw error;
    }
  },
  
  // Complete the file upload process
  completeUpload: (fileId) => {
    return api.post('/files/complete', { fileId });
  },
  
  // Helper method to handle the full upload process
  uploadFileToFileSet: async (file, fileSetId) => {
    try {
      // 1. Get a presigned URL
      const uploadData = await fileApi.getUploadUrl({
        filename: file.name,
        contentType: file.type,
        fileSetId
      });
      
      // 2. Upload the file to the URL
      await fileApi.uploadFile(uploadData.uploadUrl, file);
      
      // 3. Complete the upload
      const result = await fileApi.completeUpload(uploadData.fileId);
      
      return result;
    } catch (error) {
      console.error('Upload process failed:', error);
      throw error;
    }
  },
  
  // Delete a file by ID
  deleteFile: (fileId) => {
    return api.delete(`/files/${fileId}`);
  }
};

export default fileApi;